export default "__VITE_ASSET__JO7DncxJ__"